const enum ReglementType {
    SEE_PAYMENT = 0,
    ROOM = 1,
    DIRECTION = 2,
    HOTEL = 3,
    FREE = 4
}

export default ReglementType;